<template>
  <div>
    <div class="toolbar">
      <el-date-picker v-model="query.dateFrom" type="date" value-format="yyyy-MM-dd" placeholder="日期从" style="width:140px" />
      <el-date-picker v-model="query.dateTo" type="date" value-format="yyyy-MM-dd" placeholder="到" style="width:140px" />
      <el-input v-model="query.trackingCode" clearable placeholder="报工编号" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.orderCode" clearable placeholder="工单编号" style="width:160px" @keyup.enter.native="search" />
      <el-select v-model="query.trackingState" clearable placeholder="状态" style="width:110px">
        <el-option label="草稿" value="00" />
        <el-option label="已确认" value="01" />
        <el-option label="已驳回" value="02" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
    </div>

    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="createDate" label="登记时间" width="150" />
      <el-table-column prop="trackingCode" label="报工编号" min-width="160" show-overflow-tooltip />
      <el-table-column prop="orderCode" label="工单" min-width="140" show-overflow-tooltip />
      <el-table-column prop="operationName" label="工序" min-width="120" show-overflow-tooltip />
      <el-table-column prop="shiftName" label="班次" width="100" />
      <el-table-column prop="staffName" label="人员" width="100" />
      <el-table-column prop="qtyOut" label="合格数量" width="90" align="right" />
      <el-table-column prop="qtyScrap" label="不良数量" width="90" align="right" />
      <el-table-column prop="scrapReasonName" label="不良原因" width="120" show-overflow-tooltip />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.trackingState === '01' ? 'success' : (row.trackingState === '02' ? 'danger' : 'info')">
            {{ stateLabel(row.trackingState) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="说明" min-width="140" show-overflow-tooltip />
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listTracking } from '../../api/tracking'

const STATE_MAP = { '00': '草稿', '01': '已确认', '02': '已驳回' }

function fmt(d) {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return y + '-' + m + '-' + day
}

function defaultQuery() {
  const today = new Date()
  const from = new Date(today.getTime() - 7 * 24 * 3600 * 1000)
  return {
    dateFrom: fmt(from),
    dateTo: fmt(today),
    trackingCode: '',
    orderCode: '',
    trackingState: '01'
  }
}

export default {
  name: 'TrackingRegisterPage',
  components: { ListPagination },
  data() {
    return {
      query: defaultQuery(),
      list: [], total: 0, page: 1, pageSize: 20, loading: false
    }
  },
  created() {
    this.load()
  },
  methods: {
    stateLabel(s) { return STATE_MAP[s] || s || '-' },
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listTracking({
        currentPage: this.page,
        pageSize: this.pageSize,
        dateFrom: this.query.dateFrom,
        dateTo: this.query.dateTo,
        trackingCode: this.query.trackingCode,
        orderCode: this.query.orderCode,
        trackingState: this.query.trackingState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    }
  }
}
</script>
